import React from 'react';
import { EmailEditor } from '../../shared/components/EmailEditor';
import { RouteBasePaths, SettingsRoutes } from '../../routes';
import { EmailTemplateType } from 'shared/types/graphql';

const EmailTemplates = (): JSX.Element => {
  return (
    <EmailEditor
      type={EmailTemplateType.ServiceReminder}
      backToLocation={RouteBasePaths.Settings + SettingsRoutes.ClinicReminders}
    />
  );
};

export default EmailTemplates;
